var _a, _b, _c, _d, _e;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import view from './knowledgeDocumentsView.html';
import { groundingStatus } from '../../../../types';
import { debounce } from 'data/function';
import { ITimeoutService, translate } from 'angular';
import { getFormatDateTime } from 'data/date';
import { AlertService } from 'modules/shared/AlertService';
import TranslateService from 'modules/translate/TranslateService';
import { AgentSegmentService } from '../../../../services/AgentSegmentService';
import { BUILDER_AGENT_KNOWLEDGE_CONTENT_ADDED } from '../../../../events';
let KnowledgeDocuments = class KnowledgeDocuments {
    static $inject = ['AlertService', 'TranslateService', '$translate', '$timeout', 'AgentSegmentService'];
    constructor(AlertService, TranslateService, $translate, $timeout, AgentSegmentService) {
        'ngInject';
        this.catalogDocuments = [];
        //#region Properties
        this.hasChanges = false;
        this.searchTerm = '';
        //#endregion
        //#region Methods
        this.close = async () => {
            if (!this.hasChanges) {
                this.onClose?.();
            }
            else {
                await this.AlertService.show({
                    title: await this.$translate('knowledgeDocuments.alertLost.title'),
                    body: await this.$translate('knowledgeDocuments.alertLost.body'),
                    variant: 'warning',
                    icon: 'warning',
                    buttons: {
                        cancel: await this.$translate('knowledgeDocuments.alertLost.cancel'),
                        confirm: await this.$translate('knowledgeDocuments.alertLost.confirm'),
                    },
                    callback: {
                        cancelButtonAction: () => { },
                        confirmButtonAction: async () => { this.onClose?.(); },
                    },
                });
            }
        };
        this.updateFiltredCatalogDocuments = () => {
            this.$timeout(() => {
                if (!this.catalogDocuments) {
                    return;
                }
                if (this.searchTerm === '') {
                    this.filtredDocuments = this.catalogDocuments.map(document => ({
                        ...document,
                        selected: document.status === 'active',
                    }));
                }
                else {
                    this.filtredDocuments = this.catalogDocuments
                        .filter((document) => document.name?.toLowerCase().trim().includes(this.searchTerm.toLowerCase().trim()))
                        .map(document => ({
                        ...document,
                        selected: document.status === 'active',
                    }));
                }
            });
        };
        this.$onChanges = (changes) => {
            if (changes.isLoading && !changes.isLoading.currentValue) {
                this.updateFiltredCatalogDocuments();
            }
        };
        this.onDocumentSearch = async (event) => {
            this.searchTerm = event.detail.value;
            this.debouncedFilter();
        };
        this.onDocumentSelectionChange = async (event) => {
            this.hasChanges = true;
            const documentId = event.detail?.name;
            const document = this.catalogDocuments.find(d => d.id === documentId);
            if (!document) {
                return;
            }
            if (event.detail?.checked !== undefined) {
                document.status = event.detail.checked ? groundingStatus.ACTIVE : groundingStatus.INACTIVE;
            }
            this.updateFiltredCatalogDocuments();
        };
        this.openCatalog = () => {
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CONTENT_ADDED, { catalogName: this.agentCatalog.name });
            const url = this.getCatalogUrl();
            window.open(url, '_blank', 'noopener,noreferrer');
        };
        this.AlertService = AlertService;
        this.TranslateService = TranslateService;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.AgentSegmentService = AgentSegmentService;
    }
    //#endregion
    //#region Lifecycle Hooks
    $onInit() {
        this.debouncedFilter = debounce(this.updateFiltredCatalogDocuments, 500);
        this.catalogDocuments = this.catalogDocuments?.map(document => ({
            ...document,
            selected: document.status === 'active',
        }));
        this.filtredDocuments = this.catalogDocuments;
    }
    save() {
        this.catalogDocuments = this.catalogDocuments.map(agentDocumentCatalog => ({
            ...agentDocumentCatalog,
            version_id: undefined,
        }));
        const inactiveDocuments = this.catalogDocuments.filter(document => document.status === 'inactive');
        this.onSave({ $catalogId: this.agentCatalog.id, $inactiveCatalogDocuments: inactiveDocuments });
    }
    getFormatedDate(dateTime) {
        return getFormatDateTime(dateTime, this.TranslateService.getCurrentCulture() ?? 'pt-br');
    }
    getBaseUrl() {
        return this.application.isSubflow ? `../../../../../${this.application.callerApplication.shortName}` : '../../../..';
    }
    getCatalogUrl() {
        return `${this.getBaseUrl()}/tenant/knowledge-base/${this.agentCatalog.id}/documents`;
    }
};
KnowledgeDocuments.$inject = ['AlertService', 'TranslateService', '$translate', '$timeout', 'AgentSegmentService'];
KnowledgeDocuments = __decorate([
    Component({
        template: view,
        controllerAs: '$ctrl',
        bindings: {
            onClose: '&',
            onSave: '&',
            isLoading: '<',
            application: '<',
            agentCatalog: '<',
            catalogDocuments: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof AlertService !== "undefined" && AlertService) === "function" ? _a : Object, typeof (_b = typeof TranslateService !== "undefined" && TranslateService) === "function" ? _b : Object, typeof (_c = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _c : Object, typeof (_d = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _d : Object, typeof (_e = typeof AgentSegmentService !== "undefined" && AgentSegmentService) === "function" ? _e : Object])
], KnowledgeDocuments);
export { KnowledgeDocuments };
